module.exports = __webpack_public_path__ + "img/list-arrow.fc54463a.svg";